export default {
	types: {
		phone: "Téléphone",
	},
};
